import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import {
  array,
  date,
  eq,
  iots,
  number,
  option,
  ord,
  pipe,
  string,
  struct,
} from '@code-expert/prelude';
import { BlankConfigC } from '/imports/modules/Quizzes/clozetext/domain/BlankConfig';

//--------------------------------------------------------------------------------------------------

export const QuestionIdBrand = Symbol('QuestionId');
export const QuestionId = mkEntityIdCodec(QuestionIdBrand);
export type QuestionId = iots.TypeOf<typeof QuestionId>;
export const questionIdEq: eq.Eq<QuestionId> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const QuestionVersionIdBrand = Symbol('QuestionVersionId');
export const QuestionVersionId = mkEntityIdCodec(QuestionVersionIdBrand);
export type QuestionVersionId = iots.TypeOf<typeof QuestionVersionId>;
export const questionVersionIdEq: eq.Eq<QuestionVersionId> = string.Eq;

//--------------------------------------------------------------------------------------------------

const baseQuestionProps = {
  _id: QuestionVersionId,
  questionId: QuestionId,
  createdAt: iots.date,
  updatedAt: iots.date,
  title: iots.maxLengthString(80),
};

export const ClozeQuestion = iots.struct(
  {
    ...baseQuestionProps,
    type: iots.literal('cloze'),
  },
  {
    content: iots.string,
    blankConfigs: iots.array(BlankConfigC),
  },
);

export type ClozeQuestion = iots.TypeOf<typeof ClozeQuestion>;

export const Question = ClozeQuestion;

export type Question = iots.TypeOf<typeof ClozeQuestion>;

export const ordQuestionByDate: ord.Ord<Question> = pipe(
  date.Ord,
  ord.contramap(struct.get('createdAt')),
);

export const getQuestionOrd = (order: Array<QuestionId>): ord.Ord<Question> =>
  pipe(
    number.Ord,
    ord.contramap(({ questionId }: Question) =>
      pipe(
        order,
        array.findIndex(eq.isEqualTo(questionIdEq)(questionId)),
        option.getOrElse(() => 0),
      ),
    ),
  );
